<template>
  <v-card>
    <v-tabs
      background-color="cyan"
      dark
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
    >
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab v-for="(langPim, lang) in langs" :key="lang">
        <flag :iso="lang"></flag>
      </v-tab>
      <v-tab-item v-for="(langPim, lang) in langs" :key="lang">
        <v-textarea
          v-model="item[property][keyAttr][langPim]"
          filled
          :value="item[property][keyAttr][langPim]"
          class="vuetify-editor"
          hint="Fill your field"
          :messages="defaultValueTextAre(langPim)"
          :label="label || keyAttr"
          auto-grow
          :loading="isCompletudeRequired(bindLangAttribute(langPim))"
        ></v-textarea>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import AttributeBaseMixins from '../../mixins/attribute-base';
import CompletudeBaseMixins from '../../mixins/completude-base';
import LangBaseMixins from '../../mixins/lang-base';

export default {
  mixins: [AttributeBaseMixins, LangBaseMixins, CompletudeBaseMixins],
  name: 'attributeTextarea',
  data: () => ({
    tab: null,
  }),
  created() {
    this.initLongTextLang();
  },
  methods: {
    defaultValueTextAre(lang) {
      const defaultValues = this.getDefaultValues();
      if (!defaultValues) return '';
      return `${this.titleDefault} ${defaultValues[lang]}`;
    },
  },
};
</script>
